import { BarChart3, Mail, MoreHorizontal } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useIsMobile } from '@/hooks/use-mobile'
import { eventSegmentPath } from '@/pages/segmentEventPrefill'

export function EventReportActions({
  eventId,
  onReport,
  onSegment,
}: {
  eventId: number
  onReport: () => void
  onSegment?: () => void
}) {
  const mobile = useIsMobile()
  const actions = [
    {
      label: 'Registrations report',
      href: `/reports/event-registrations?event_id=${eventId}`,
      onOpen: onReport,
      Icon: BarChart3,
    },
    ...(onSegment
      ? [
          {
            label: 'Email people who have not booked',
            href: eventSegmentPath(eventId),
            onOpen: onSegment,
            Icon: Mail,
          },
        ]
      : []),
  ]
  const links = actions.map(({ label, href, onOpen, Icon }) => (
    <a
      key={label}
      href={href}
      onClick={(event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
          return
        event.preventDefault()
        onOpen()
      }}
    >
      <Icon className="mr-1.5 h-4 w-4" aria-hidden="true" />
      {label}
    </a>
  ))
  if (!mobile)
    return (
      <>
        {links.map((link) => (
          <Button key={link.key} asChild variant="outline">
            {link}
          </Button>
        ))}
      </>
    )
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="outline">
          <MoreHorizontal className="mr-1.5 h-4 w-4" aria-hidden="true" />
          More
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {links.map((link) => (
          <DropdownMenuItem key={link.key} asChild>
            {link}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
